import axios from "axios";
import agent from "./agent";

export function getEventList(search, page, limit) {
  return agent.get("events/getList", {
    params: { search, skip: page * limit, limit },
  });
}

export function getEventDetail(id) {
  return agent.get(`events/${id}/getDetail`);
}

export function createEvent(body) {
  return agent.post("events/createEvent", body);
}

export function editEvent(id, body) {
  return agent.put(`events/${id}/editEvent`, body);
}

export function getEventTxList(eventId, search, page, limit, hasRunners) {
  return agent.get("transactions/getEventTxList", {
    params: {
      eventId,
      search: search || undefined,
      skip: page != null && limit != null ? page * limit : undefined,
      limit: limit || undefined,
      hasRunners: hasRunners || undefined,
    },
  });
}

export function getUsedTickets(eventId, page, limit, search) {
  return agent.get("events/getUsedTickets", {
    params: { eventId, skip: page * limit, limit, search: search || undefined },
  });
}

export function getCollectedJerseys(eventId, page, limit, search) {
  return agent.get("events/getCollectedJerseys", {
    params: { eventId, skip: page * limit, limit, search: search || undefined },
  });
}

export function getPresignedUrl(key) {
  return agent.post("UploadedFiles/getPresignedUrl", { key });
}

export function getSalesAndCheckInSummary(eventId) {
  return agent.get("events/getSalesAndCheckInSummary", { params: { eventId } });
}

export function getTicketDetail(code) {
  return agent.get("events/getTicketDetail", { params: { code } });
}

export function simulatePayment(externalId) {
  return agent.post("client-event/simulatePayment", { externalId }, {
    headers: {
      "x-api-key": process.env.REACT_APP_CLIENT_EVENT_API_KEY || "calendar-migrate-api-key-2025",
    },
  });
}

export function resendTicket(email, txId) {
  return axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/client-event/resendTicket`,
    { email, txId },
    {
      headers: {
        "x-api-key":
          process.env.REACT_APP_CLIENT_EVENT_API_KEY ||
          "calendar-migrate-api-key-2025",
        "Content-Type": "application/json",
      },
    }
  );
}
